<script setup lang="ts">
import { computed } from "vue";
import { useI18n } from "vue-i18n";
import { runtimeConfig } from "../runtime-config";

const { t } = useI18n();
const autumnSoftUrl = computed(() =>
  runtimeConfig.market.isChinaVersion ? "https://www.autumnsoft.cn" : "https://www.autumnsoft.net"
);
</script>

<template>
  <footer class="site-footer">
    <div class="site-footer__main">
      <span>
        {{ t("footer.copyrightPrefix") }}
        <a :href="autumnSoftUrl" target="_blank" rel="noreferrer">{{ t("footer.copyrightBrand") }}</a>
        {{ t("footer.copyrightSuffix") }}
      </span>
      <a v-if="runtimeConfig.market.showIcp" href="https://beian.miit.gov.cn/" target="_blank" rel="noreferrer">
        {{ t("footer.icp") }}
      </a>
    </div>
    <nav class="site-footer__links" :aria-label="t('footer.legalNav')">
      <RouterLink to="/privacy">{{ t("footer.privacy") }}</RouterLink>
      <RouterLink to="/terms">{{ t("footer.terms") }}</RouterLink>
    </nav>
  </footer>
</template>
